<template>

  <div>

    <!-- CARD 1: Activitats -->
    <div class="card rounded-0" style="margin-top: -17px;">

      <div class="card-header rounded-0 bg-dark-upc d-flex justify-content-between align-items-center">
        <span class="mt-2 mb-2" style="font-weight: 500;">{{ $t("Activitats") }}</span>
        <span class="float-right"><i class="fas fa-fill"></i></span>
      </div>

      <div v-for="(entries, key) in firstPartParsedData" :key="key">
        <div class="card-body bg-dark-upc" v-if="entries.length > 0">
          <!-- TITLE -->
          <div class="pt-2 custom-title">
            <span v-if="entries.length <= 5">
              <span role="button" class="me-2 disabled no-pointer custom-title">{{ $t(key) }}</span>
            </span>
            <span v-else>
              <span role="button" class="me-2" @click="expanded[key] = !expanded[key]" :aria-expanded="expanded[key]">
                <span v-if="entries.length > 5 && !expanded[key]">+ </span>
                <span v-else>- </span>
                {{ $t(key) }}
              </span>
            </span>
            <!--button class="btn btn-light border rounded-0 btn-sm" @click="openModal(key)" data-bs-toggle="modal" data-bs-target="#infoModal" aria-label="Info">
              <i class="fas fa-info fa-sm"></i>
            </button-->
          </div>

          <!-- CONTENT -->
          <div>
            <div v-for="(entry, index) in getDisplayedEntries(entries, key)" :key="index">
              <div class="opcio-filtre">
                <!-- No filter -->
                <span v-if='!isFacetInURL(key, entry)' ref="list">
                  <span v-if="key === 'data'" role="button" class="link-a" @click='applyFilter(key, entry[0])'>{{entry[0]}}</span>
                  <span v-else role="button" class="link-a" @click='applyFilter(key, entry[0])'>{{$t(entry[0])}}</span>
                  <span class="badge rounded-pill bg-light text-dark border ms-1">{{entry[1].toLocaleString()}}</span>
                </span>
                <!-- Yes filter -->
                <span v-else>
                  <span v-if="key === 'data'" role="button" class="link-a" @click='applyFilter(key, entry[0])'>{{entry[0]}}</span>
                  <span v-else class="text-secondary fw-bolder">{{$t(entry[0])}}</span>
                  <span class="badge rounded-pill bg-dark ms-1">{{entry[1].toLocaleString()}}</span>
                  <span class="badge rounded-pill bg-danger ms-1" style="cursor: pointer;" @click='removeFilter(key, entry[0])'>X</span>
                </span>
              </div>
            </div>

            <button class="btn btn-secondary btn-sm mt-2" v-if="entries.length > 5 && !expanded[key]" @click="expanded[key] = !expanded[key]">{{ $t("Més") }}...</button>
            <button class="btn btn-secondary btn-sm mt-2" v-if="entries.length > 5 && expanded[key]" @click="expanded[key] = !expanded[key]">{{ $t("Menys") }}...</button>

          </div>
          <!--div v-for="(entry, index) in entries" :key="index">
            <p>{{ entry[0] }}: {{ entry[1] }}</p>
          </div-->
        </div>
      </div>
    </div>

    <!-- CARD 2: Filter results -->
    <div class="card rounded-0 mt-4">

      <div class="card-header rounded-0 bg-light-upc d-flex justify-content-between align-items-center">
        <span class="mt-2 mb-2" style="font-weight: 500;">{{ $t("Filtra els resultats") }}</span>
        <span class="float-right"><i class="fas fa-filter"></i></span>
      </div>

      <div v-for="(entries, key) in secondPartParsedData" :key="key">
        <div class="card-body bg-light-upc" v-if="entries.length > 0">

          <!-- TITLE -->
          <div class="pt-2 custom-title">
            <span v-if="entries.length <= 5">
              <span role="button" class="me-2 disabled no-pointer custom-title">{{ $t(key) }}</span>
            </span>
            <span v-else>
              <span role="button" class="me-2" @click="expanded[key] = !expanded[key]" :aria-expanded="expanded[key]">
                <span v-if="entries.length > 5 && !expanded[key]">+ </span>
                <span v-else>- </span>
                {{ $t(key) }}
              </span>
            </span>
            <!--button class="btn btn-light border rounded-0 btn-sm" @click="openModal(key)" data-bs-toggle="modal" data-bs-target="#infoModal" aria-label="Info">
              <i class="fas fa-info fa-sm"></i>
            </button-->
          </div>

          <!-- CONTENT -->
          <div>
            <div v-for="(entry, index) in getDisplayedEntries(entries, key)" :key="index">
              <div class="opcio-filtre">
                <!-- No filter -->
                <span v-if='!isFacetInURL(key, entry)' ref="list">
                  <span v-if="key === 'data'" role="button" class="link-a" @click='applyFilter(key, entry[0])'>{{entry[0]}}</span>
                  <span v-else role="button" class="link-a" @click='applyFilter(key, entry[0])'>{{$t(entry[0])}}</span>
                  <span class="badge rounded-pill bg-light text-dark border ms-1">{{entry[1].toLocaleString()}}</span>
                </span>
                <!-- Yes filter -->
                <span v-else>
                  <span v-if="key === 'data'" role="button" class="link-a" @click='applyFilter(key, entry[0])'>{{entry[0]}}</span>
                  <span v-else class="text-secondary fw-bolder">{{$t(entry[0])}}</span>
                  <span class="badge rounded-pill bg-dark ms-1">{{entry[1].toLocaleString()}}</span>
                  <span class="badge rounded-pill bg-danger ms-1" style="cursor: pointer;" @click='removeFilter(key, entry[0])'>X</span>
                </span>
              </div>
            </div>

            <button class="btn btn-secondary btn-sm mt-2" v-if="entries.length > 5 && !expanded[key]" @click="expanded[key] = !expanded[key]">{{ $t("Més") }}...</button>
            <button class="btn btn-secondary btn-sm mt-2" v-if="entries.length > 5 && expanded[key]" @click="expanded[key] = !expanded[key]">{{ $t("Menys") }}...</button>

          </div>
          <!--div v-for="(entry, index) in entries" :key="index">
            <p>{{ entry[0] }}: {{ entry[1] }}</p>
          </div-->
        </div>
      </div>
    </div>



    <!-- CARD 3: Academic framework -->
    <div class="card rounded-0 mt-4" v-if="marc">

      <div class="card-header bg-white d-flex justify-content-between align-items-center">
        <span class="mt-2 mb-2" style="font-weight: 500;">{{ $t("Xarxa de col·laboració UPC") }}</span>
        <span class="float-right"><i class="fas fa-sitemap"></i></span>
      </div>

      <div v-for="(entries, key) in thirdPartParsedData" :key="key">
        <div class="card-body bg-white" v-if="entries.length > 0">

          <!-- TITLE -->
          <div class="pt-2 custom-title">
            <span v-if="entries.length <= 5">
              <span role="button" class="me-2 link-a disabled no-pointer custom-title">{{ $t(key) }}</span>
            </span>
            <span v-else>
              <span role="button" class="link-a me-2 custom-title" @click="expanded[key] = !expanded[key]">
                  <span v-if="entries.length > 5 && !expanded[key]">+ </span>
                  <span v-else>- </span>
                  {{ $t(key) }}
              </span>
            </span>

            <!--button class="btn btn-light border rounded-0 btn-sm" @click="openModal(key)" data-bs-toggle="modal" data-bs-target="#infoModal" aria-label="Más información">
              <i class="fas fa-info fa-sm"></i>
            </button-->
          </div>

          <!-- CONTENT -->
          <div>
            <div v-for="(entry, index) in getDisplayedEntries(entries, key)" :key="index">

              <div class="opcio-filtre">
                <!-- No filter -->
                <span v-if='!isFacetInURL(key, entry)' ref="list">
                  <span v-if="key === 'activitat_professors_faceta' && entry[0].substring(entry[0]).includes('::')" role="button" class="link-a" @click='applyFilter(key, entry[0].substring(entry[0].lastIndexOf(":")+1))'>{{entry[0].substring(0, entry[0].indexOf(":"))}}</span>
                  <span v-else role="button" class="link-a" @click='applyFilter(key, entry[0])'>{{$t(entry[0])}}</span>
                  <span class="badge rounded-pill bg-light text-dark border ms-1">{{entry[1].toLocaleString()}}</span>
                </span>
                <!-- Yes filter -->
                <span v-else>

                  <span v-if="key === 'activitat_professors_faceta'">
                    <span class="text-secondary fw-bolder">{{entry[0].substring(0, entry[0].indexOf(":"))}}</span>
                    <span class="badge rounded-pill bg-dark ms-1">{{entry[1].toLocaleString()}}</span>
                    <span class="badge rounded-pill bg-danger ms-1" style="cursor: pointer;" @click='removeFilter(key, entry[0].substring(entry[0].lastIndexOf(":")+1))'>X</span>
                  </span>
                  <span v-else>
                    <span class="text-secondary fw-bolder">{{$t(entry[0])}}</span>
                    <span class="badge rounded-pill bg-dark ms-1">{{entry[1].toLocaleString()}}</span>
                    <span class="badge rounded-pill bg-danger ms-1" style="cursor: pointer;" @click='removeFilter(key, entry[0])'>X</span>
                  </span>


                </span>

                <!-- Profile links -->
                <span v-if="profileLink(key) === 'centre' || profileLink(key) === 'departament' || profileLink(key) === 'institut'">
                  <router-link-locale :to="{name: 'organitzacio', params: {/*tipus:profileLink(key),*/ id: entry[0]}}" aria-label="Organization link"><i class="fa-solid fa-file-lines mx-1 text-blue"></i> </router-link-locale>
                </span>
                <span v-else-if="profileLink(key) === 'professors'">
                  <router-link-locale :to="{name: 'professor', params: {id: entry[0].substring(entry[0].lastIndexOf(':')+1)}}" aria-label="Teacher link"><i class="fa-solid fa-file-lines mx-1 text-blue"></i> </router-link-locale>
                  <!--span v-else class="text-upc-green">sss{{ entry[0] }}</span-->
                </span>
                <span v-else-if="key !== 'professor_campus'">
                  <router-link-locale :to="{name: profileLink(key), params: {id: entry[0]}}" aria-label="Campus link"><i class="fa-solid fa-file-lines mx-1 text-blue"></i> </router-link-locale>
                </span>
              </div>
            </div>

            <button class="btn btn-outline-secondary btn-sm mt-2" v-if="entries.length > 5 && !expanded[key]" @click="expanded[key] = !expanded[key]">{{ $t("Més") }}...</button>
            <button class="btn btn-outline-secondary btn-sm mt-2" v-if="entries.length > 5 && expanded[key]" @click="expanded[key] = !expanded[key]">{{ $t("Menys") }}...</button>

          </div>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="infoModal" tabindex="-1" aria-labelledby="infoModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="infoModalLabel">{{ $t(selectedItem) }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body pre-line">
            {{ $t(`info-modal-${selectedItem}`) }}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>



  </div>

</template>
<script>
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import RouterLinkLocale from "@/components/RouterLinkLocale.vue";

export default {
  name: "FacetesFilter",
  components: { RouterLinkLocale },

  props: {
    data: {
      type: Object,
      required: true
    },
    splitIndex: {
      type: Number,
      required: true,
      default: 1
    },
    splitIndex2: {
      type: Number,
      required: true,
      default: 2
    },
    marc: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();

    const expanded = ref([]);
    const xarxaDesactivada = ref(false);
    const selectedItem = ref('professor_actiu');

    const parseList = (list) => {
      const result = [];
      for (let i = 0; i < list.length; i += 2) {
        result.push([list[i], list[i + 1]]);
      }
      return result;
    };

    const parsedData = computed(() => {
      const result = {};
      for (const key in props.data) {
        result[key] = parseList(props.data[key]);
      }
      return result;
    });

    const firstPartParsedData = computed(() => {
      return Object.keys(parsedData.value).slice(0, props.splitIndex).reduce((result, key) => {
        //console.log(props.splitIndex)
        result[key] = parsedData.value[key];
        return result;
      }, {});
    });

    const secondPartParsedData = computed(() => {
      return Object.keys(parsedData.value).slice(props.splitIndex, props.splitIndex2).reduce((result, key) => {
        result[key] = parsedData.value[key];
        return result;
      }, {});
    });

    const thirdPartParsedData = computed(() => {
      return Object.keys(parsedData.value).slice(props.splitIndex2).reduce((result, key) => {
        result[key] = parsedData.value[key];
        return result;
      }, {});
    });

    const getDisplayedEntries = (entries, key) => {
      if (expanded.value[key]) {
        return entries;
      }
      return entries.slice(0, 5);
    };

    const applyFilter = (filterName, filterValue) => {
      const currentQuery = { ...route.query };
      if (currentQuery[filterName]) {
        const existingValues = currentQuery[filterName].split(',');
        if (!existingValues.includes(filterValue)) {
          currentQuery[filterName] = [...existingValues, filterValue].join(',');
        }
      } else {
        currentQuery[filterName] = filterValue;
      }
      router.push({ query: currentQuery });
      emit('apply-filter', { query: currentQuery });
    };

    const removeFilter = (filterName, filterValue = null) => {
      const currentQuery = { ...route.query };
      if (currentQuery[filterName]) {
        if (filterValue) {
          const values = currentQuery[filterName].split(',');
          const newValues = values.filter(value => value !== filterValue);
          if (newValues.length > 0) {
            currentQuery[filterName] = newValues.join(',');
          } else {
            delete currentQuery[filterName];
          }
        } else {
          delete currentQuery[filterName];
        }
        router.push({ query: currentQuery });
        emit('apply-filter', { query: currentQuery });
      }
    };

    const isFacetInURL = (key, entry) => {
      if (key === "activitat_professors_faceta") {
        const currentQuery = route.query[key];
        if (currentQuery !== undefined) {
          const searchString = entry[0];
          if (currentQuery) {
            const values = currentQuery.split(',');
            let name = searchString.substring(searchString.lastIndexOf(":") + 1).trim();
            return values.includes(name);
          }
        }
        return false;
      } else {
        const searchString = entry[0];
        const currentQuery = route.query[key];
        if (currentQuery) {
          const values = currentQuery.split(',');
          return values.includes(searchString);
        }
        return false;
      }
    };

    onMounted(() => {
      const queryKeys = Object.keys(route.query);
      queryKeys.forEach(key => {
        expanded.value[key] = true;
      });
    });

    const profileLink = (field) => {
      if (field.indexOf('centre') !== -1) return 'centre';
      else if (field.indexOf('departament') !== -1) return 'departament';
      else if (field.indexOf('institut') !== -1) return 'institut';
      else if (field.indexOf('titulacio') !== -1) return 'titulacio';
      else if (field.indexOf('assignatures') !== -1) return 'assignatura';
      else if (field.indexOf('professors') !== -1) return 'professors';
      else return '';
    };

    const openModal = (item) => {
      selectedItem.value = item;
    };

    return {
      expanded,
      xarxaDesactivada,
      parsedData,
      firstPartParsedData,
      secondPartParsedData,
      thirdPartParsedData,
      selectedItem,
      getDisplayedEntries,
      applyFilter,
      removeFilter,
      isFacetInURL,
      profileLink,
      openModal
    };
  }
};
</script>

<style scoped>

.bg-dark-upc {
  /* azul: #e4e9f1 */
  background-color: #dde6f3 !important;
}

.bg-light-upc {
  background-color: whitesmoke !important;
}

.list-group li { background: whitesmoke; }
.list-group li:nth-child(odd) { background: white; }

.card-header {
  border-bottom: 5px solid #5fa728 !important;
}

.card-body {
  border-bottom: 1px solid #dfdfdf !important;
}

/*.card-footer {
  border-top: 5px solid #0479be !important;
}*/

/*div.card-body h3 a {
  color: #5fa728;
  font-size: 16px;
}

div.card-body h3 {
  font-size: 14px;
  line-height: 16px;
  color: #960b04;
  margin-top: 0;
}*/

div.card-body .opcio-filtre{
  margin-top: 10px;
}

.pre-line {
  white-space: pre-line;
}

.custom-title {
  /*color: #5fa728;*/
  color: #21644b;
  font-size: 16px;
  font-weight: 500;
}

.custom-title:hover {
  /*color: #5fa728;*/
  color: #21644b;
  font-size: 16px;
  font-weight: 500;
}

/*.custom-title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #960b04;
  margin-top: 0;
}*/
</style>
